import * as React from 'react';
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from 'components/chat/Header';
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import TopicIcon from '@mui/icons-material/Topic';
import ShareIcon from '@mui/icons-material/Share';
import '../styles/F2.scss';

export default function F2() {
  const [openMenuLeft, setOpenMenuLeft] = useState<boolean>(true);
  const pages = [
    { name: 'チャット', path: '/f2', icon: <TopicIcon /> },
    { name: '共有チャット', path: '/f2/share-drives', icon: <ShareIcon /> },
  ];
  const [showText, setShowText] = useState<boolean>(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (openMenuLeft) {
      setTimeout(() => {
        setShowText(true);
      }, 300);
    } else {
      setShowText(false);
    }
  }, [openMenuLeft]);

  const handleSignOut = () => {
    navigate('/home');
  };

  return (
    <>
      <Header />
      <div className="layout">
        <Box
          className="menu-left"
          sx={{
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            width: openMenuLeft ? '14rem' : '4rem',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'right' }}>
              <IconButton onClick={() => setOpenMenuLeft(!openMenuLeft)}>
                {openMenuLeft ? (
                  <KeyboardArrowLeftIcon />
                ) : (
                  <KeyboardArrowRightIcon />
                )}
              </IconButton>
            </Box>
            <List>
              {pages.map((item, index) => (
                <ListItem
                  key={item.name}
                  disablePadding
                  component={Link}
                  to={item.path}
                  sx={{ color: 'inherit', textDecoration: 'none' }}
                >
                  <ListItemButton
                    selected={location.pathname === item.path}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    {showText && <ListItemText primary={item.name} />}
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
          <List disablePadding>
            <ListItem disablePadding>
              <ListItemButton onClick={handleSignOut}>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                {showText && <ListItemText primary={'ログアウト'} />}
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
        <Box
          className="page-content"
          sx={{
            width: openMenuLeft ? 'calc(100vw - 14rem)' : 'calc(100vw - 4rem)',
          }}
        >
          <Outlet />
        </Box>
      </div>
    </>
  );
}
